<template lang="pug">
b-modal#integration-detail(title='Integration Summary', :hide-footer='true')
  .d-flex.justify-content-center(v-if='integrationDetail && integrationDetail.email')
    .card-item.d-flex.justify-content-center.align-items-center
      img(src='../../assets/github.svg', v-if='isGithub')
      img(src='../../assets/habitica.svg', v-else)
      div
        strong Linked to:
        span {{integrationDetail.email}}
  .d-flex.justify-content-center(v-if='integrationDetail && !integrationDetail.advanced')
    .card-item
      strong Add Advance Github
      p
        | This will require private access but will allow you to get points for private activity.
        | Currently, Github requires us to have all or nothing access to private repos.
      .btn.btn-green(@click='loginGithubPrivate()') Connect
  .remove-wrap(v-if='isGithub', @click="removeIntegration()")
    .remove Remove Integration
</template>

<style lang="scss">
  // @TODO: share
  #integration-detail {
    .modal-content {
      border-radius: 16px;
      border: none;
    }

    .modal-dialog {
      // width: 588px;
      border-radius: 16px;
      background-color: #ffffff;

      .modal-header {
        border-radius: 16px 16px 0 0;
        background-image: linear-gradient(to right, #9bc75a, #3ba5a8);

        h5.modal-title {
          margin-left: 11em;
          text-align: center;
          text-transform: uppercase;
          font-size: 14px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.43;
          letter-spacing: 1px;
          text-align: center;
          color: #ffffff;
          // margin: 0 auto;
        }
      }

      button {
        color: #fff;
        opacity: 1;
        text-shadow: none;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .card-item {
    border-radius: 8px;
    background-color: #f7f8f6;
    display: inline-block;
    padding: 1.5rem 2rem;
    max-width: 385px;
    margin-bottom: 1rem;

    img {
      width: 38.4px;
      margin-right: 1rem;
    }

    strong {
      margin-right: .5rem;
    }
  }

  .remove-wrap {
    padding: 1rem 1.5rem;
  }

  .remove {
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    text-align: center;
    color: #e14455;
  }

  .remove:hover {
    cursor: pointer;
  }
</style>

<script>
import axios from 'axios';
import oauth from '../../mixins/oauth';

export default {
  mixins: [oauth],
  data() {
    return {
      integration: {},
    };
  },
  mounted() {
    this.$root.$on('show-integration-detail', this.showIntegrationDetail);
  },
  destroyed() {
    this.$root.$off('show-integration-detail', this.showIntegrationDetail);
  },
  computed: {
    isGithub() {
      return this.integration && (this.integration.email || (this.integration[0] && this.integration[0].provider === 'Github'));
    },
    integrationDetail() {
      return this.integration && this.integration.length ? this.integration[0] : this.integration;
    },
  },
  methods: {
    shown() {
      window.amplitude.getInstance().logEvent('VIEW_INTEGRATION_DETAIL');
    },
    showIntegrationDetail(data) {
      this.integration = data.integration;
      this.$root.$emit('bv::show::modal', 'integration-detail');
    },
    async loginGithubPrivate() {
      await axios.delete(`/integrations/${this.integrationDetail._id}`).catch(e => console.error(e));

      const redirectURl = window.location.href;
      //  30d458bd2397a8e325f6'; // 71c29a3b6b32b66d88ea
      const githubUrl = 'https://github.com/login/oauth/authorize?client_id=30d458bd2397a8e325f6&scope=user:email%20read:org%20repo';
      this.openSocialLoginWindow(githubUrl, redirectURl, 'Github', true);

      this.$root.$emit('bv::hide::modal', 'integration-detail');
    },
    removeIntegration() {
      if (!confirm('Are you sure you want to remove this?')) return;

      this.$delete(this.$store.state.integrations, this.integrationDetail.provider);

      axios.delete(`/integrations/${this.integrationDetail._id}`);

      this.$root.$emit('bv::hide::modal', 'integration-detail');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/integration/IntegrationDetail.vue